class SizeGuideDialog {
  static SELECTOR = '.pdp-order-5 > .text-block.paragraph:first-child';
  static GUIDE_URL = '/pages/guide-des-tailles';

  constructor() {
    this.dialog = null;
    this.trigger = null;
  }

  init() {
    const textBlock = document.querySelector(SizeGuideDialog.SELECTOR);
    if (!textBlock) return;

    const spans = textBlock.querySelectorAll('p > span');
    if (spans.length < 2) return;

    this.trigger = spans[spans.length - 1];
    this.trigger.setAttribute('role', 'button');
    this.trigger.setAttribute('tabindex', '0');

    this.#createDialog();
    this.#bindEvents();
  }

  #createDialog() {
    const section = this.trigger.closest('.shopify-section');
    const animationSpeed = section
      ? getComputedStyle(section).getPropertyValue('--animation-speed').trim()
      : '0.3s';

    this.dialog = document.createElement('dialog');
    this.dialog.className = 'dialog-modal dialog-modal--full-width card color-scheme-1';
    this.dialog.setAttribute('data-ref', 'size-guide-modal');
    this.dialog.style.setProperty('--animation-speed-local', animationSpeed);

    this.dialog.innerHTML = `
      <div class="dialog-modal__content size-guide-dialog__content">
        <div class="size-guide-dialog__loading">
          <div class="spinner"><svg class="path" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle></svg></div>
        </div>
      </div>
      <div class="dialog-modal__close">
        <button class="button button--secondary button--small" data-ref="size-guide-close" aria-label="Fermer">
          Fermer
        </button>
      </div>
    `;

    document.body.appendChild(this.dialog);
  }

  #bindEvents() {
    this.trigger.addEventListener('click', () => this.#open());
    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.#open();
      }
    });

    const closeBtn = this.dialog.querySelector('[data-ref="size-guide-close"]');
    closeBtn.addEventListener('click', () => this.#close());

    this.dialog.addEventListener('click', (e) => {
      const rect = this.dialog.getBoundingClientRect();
      const isInDialog =
        rect.top <= e.clientY &&
        e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX &&
        e.clientX <= rect.left + rect.width;
      if (!isInDialog) this.#close();
    });

    this.dialog.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
    });
  }

  async #open() {
    this.dialog.showModal();
    this.dialog.scrollTop = 0;
    document.body.classList.add('overflow-hidden');

    if (!this.loaded) {
      await this.#loadContent();
    }
  }

  #close() {
    this.dialog.classList.add('dialog-modal--closing');

    const handleEnd = () => {
      this.dialog.classList.remove('dialog-modal--closing');
      this.dialog.removeEventListener('animationend', handleEnd);
      this.dialog.close();
    };

    this.dialog.addEventListener('animationend', handleEnd);
    setTimeout(() => {
      if (this.dialog.classList.contains('dialog-modal--closing')) {
        handleEnd();
      }
    }, 500);
  }

  async #loadContent() {
    try {
      const response = await fetch(SizeGuideDialog.GUIDE_URL);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Remove header, footer, breadcrumbs, scripts and non-content sections
      doc.querySelectorAll(
        'header, footer, script, style, link, .shopify-section-group-header-group, .shopify-section-group-footer-group, .shopify-section-group-breadcrumbs-group'
      ).forEach(el => el.remove());

      // Collect all remaining shopify sections (skip the main-page meta section)
      const sections = doc.querySelectorAll('.shopify-section:not([id*="main-page"])');
      const contentEl = this.dialog.querySelector('.size-guide-dialog__content');

      if (sections.length > 0) {
        contentEl.innerHTML = '';
        sections.forEach(section => contentEl.appendChild(section.cloneNode(true)));
      } else {
        contentEl.innerHTML = doc.body.innerHTML;
      }
      this.loaded = true;
    } catch (err) {
      const contentEl = this.dialog.querySelector('.size-guide-dialog__content');
      contentEl.innerHTML = '<p>Impossible de charger le guide des tailles.</p>';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sizeGuide = new SizeGuideDialog();
  sizeGuide.init();
});
